module.exports = __webpack_public_path__ + "static/media/settings-icon.1e373c53.svg";